import { SubscriptionCheck } from "../../../../components/Access/helper/subscription/SubscriptionCheck";
import { RowType } from "../../../../components/Editable/FormItem/Rows/RowType";

/**
 * Remove non-base uom items from form items / stock items if user does not have UOM subscription
 */
export const processItemsRemoval = ({
    items = [],
    productList,
    subscriptionScopeKey,
    checkShouldRemoveItem = (item, product) => {
        console.log('aaa checkShouldRemoveItem', {item, product});
    },
    // processMode = 'remove', // to remove line; or 'base' to replace with base uom
}) => {
    const hasScopeSubscription = SubscriptionCheck
        .withKeys(subscriptionScopeKey)
        .hasSubscriptionTo();

    return items.reduce(
        ({newItems, removedItems}, item) => {
            if (!hasScopeSubscription) {
                const product = productList.find(p => p.id === item.product_id);

                // const baseUom = product?.units?.find(u => u.is_base);
                // const shouldRemoveItem = (item.product_unit_id && baseUom?.id !== item.product_unit_id);

                const shouldRemoveLineItem = checkShouldRemoveItem(item, product);
                // console.log('aaa item,', {
                //     line: item.line,
                //     item,
                //     currentFormItemUom: item.product_unit_id,
                //     // baseUom: baseUom?.id,
                //     shouldRemoveLineItem,
                //     productList,
                // });

                // terminate early if need to remove (newItems === next newItems)
                if (shouldRemoveLineItem) {
                    return {
                        newItems,
                        removedItems: [...removedItems, item],
                    };
                }
            }

            // Bundle need to iterate children
            if (item.type === RowType.bundle) {
                const {
                    newItems: newBundleFormItems,
                    removedItems: newRemovedItems,
                } = processItemsRemoval({
                    items: item.children,
                    productList,
                    subscriptionScopeKey,
                    checkShouldRemoveItem,
                });
                const allBundleItemsRemoved = newBundleFormItems.length === 0;
                const newBundleItem = {
                    ...item,
                    children: newBundleFormItems,
                };

                // remove bundle container if no children
                const procNewFormItems = allBundleItemsRemoved ?
                    newItems :
                    [...newItems, newBundleItem];

                return {
                    newItems: procNewFormItems,
                    removedItems: [
                        ...removedItems,
                        ...newRemovedItems,
                    ],
                };
            }

            return {
                newItems: [...newItems, item],
                removedItems,
            };
        }, { newItems: [], removedItems: []});
};
